import { useTranslation } from "react-i18next";

export function Terms() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className="sub-container">
        <div className="txt_box">
          <span className="txt_title">{t("page.terms.kquake.title")}</span>
          <ol>
            <li className="point-style">{t("page.terms.kquake.content.1")}</li>
            <li className="point-style">
              {t("page.terms.kquake.content.2")}
              <p style={{ border: "1px solid #AAA", padding: 20 }}>
                KIGAM Quake: An open platform for seismological data and
                earthquake research information
                <br />
                Lee, M. G., Kim, Y., Cho, H. I., Kim, H. S., Sun, C. G., Seong,
                Y. J., Che, I. Y.
                <br />
                Geomechanics and Engineering (2024) 37(3): 279-291.
                <br />
                DOI:{" "}
                <a
                  href="https://doi.org/10.12989/gae.2024.37.3.279"
                  target="_blank"
                >
                  https://doi.org/10.12989/gae.2024.37.3.279
                </a>
              </p>
            </li>
            <li className="point-style">{t("page.terms.kquake.content.3")}</li>
            <li className="point-style">{t("page.terms.kquake.content.4")}</li>
          </ol>
        </div>
        <div className="txt_box">
          <span className="txt_title">{t("page.terms.geobig.title")}</span>
          <ol>
            <li className="point-style">{t("page.terms.geobig.content.1")}</li>
            <li className="point-style">{t("page.terms.geobig.content.2")}</li>
            <li className="point-style">{t("page.terms.geobig.content.3")}</li>
            <li className="point-style">{t("page.terms.geobig.content.4")}</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
